import React, { MouseEventHandler } from 'react';
import { twMerge } from 'tailwind-merge';
import Icon, { IconKey } from '../ui-components/Icon';
import IconButton from '../ui-components/IconButton';
import { OriginalPlacements } from '../ui-components/Tooltip';

interface Props {
    onClick?: MouseEventHandler;
    label?: string;
    iconKey: IconKey;
    disabled?: boolean;
    tooltipPlacement?: OriginalPlacements;
    size: 'small' | 'medium' | 'large';
    activeBg?: boolean;
    inactiveBgColor?: string;
    className?: string;
    /** For a <label htmlFor> that activates the button from its text. */
    id?: string;
}

const GenericSmallIconButton = ({
    onClick,
    label,
    iconKey,
    disabled,
    tooltipPlacement,
    size = 'small',
    activeBg = false,
    inactiveBgColor,
    className,
    id,
}: Props) => {
    let iconSize = 'size-8'; // Default size

    if (size === 'small') {
        iconSize = 'size-8';
    } else if (size === 'medium') {
        iconSize = 'size-10';
    } else if (size === 'large') {
        iconSize = 'size-12';
    }
    return (
        <IconButton
            id={id}
            className={twMerge(
                'cursor-pointer',
                className,
                iconSize,
                activeBg
                    ? 'bg-green hover:darken-20 text-white'
                    : `group-hover:bg-green ${inactiveBgColor || 'bg-gray-200'} group-hover:text-white`,
            )}
            data-test-id={'generic-small-call-icon-button'}
            disabled={disabled}
            onClick={onClick}
            tooltipLabel={label}
            tooltipPlacement={tooltipPlacement}
        >
            <Icon iconKey={iconKey} />
        </IconButton>
    );
};

export default React.memo(GenericSmallIconButton);
